import ApiService from "src/services/ApiService";

const TRANSLATE = {
  newest: "Mới nhất",
  pageview: "Top View",
  realtime: "Realtime",
};

const buildQueryString = (filters = {}) => {
  let queryString = "";

  Object.entries(filters).forEach(([key, value], index) => {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      queryString += `${index ? "&" : ""}${key}=${value}`;
    }

    if (typeof value === "object") {
      value.forEach((v) => {
        queryString += `${index ? "&" : ""}${key}=${v}`;
      });
    }
  });

  return queryString;
}

const getHome = async () => {
  return await ApiService.get("/home");
};


const getPosts = async (filters = {}) => {
  if(!filters.hasOwnProperty('hidden_ne')){
    filters.hidden_ne =  true;
  }
  if(!filters.hasOwnProperty('channel')){
    filters.channel =  1;
  }
  const queryString = buildQueryString(filters);

  return await ApiService.get(`/posts?${queryString}`);
};

const getRealtimePosts = async () => {
  // return await ApiService.get("/top-view-posts");
  const { posts: rows = {} } = await ApiService.get("/top-view-posts");
  const incrementIdList = [];
  rows.forEach((row) => {
    incrementIdList.push(row.increment_id);
  });

  let queryString = "";
  // const testIdList = ["7206777", "7177659"];
  incrementIdList.forEach((id, index) => {
    queryString += `${index ? "&" : ""}increment_id_in=${id}`;
  });
  const postsData = await ApiService.get(`/posts?${queryString}`);

  if (postsData.posts) {
    return postsData.posts;
  }

  return [];
};

const updateHome = (data) => {
  return ApiService.put("/home", data);  
};

const resizeImage = (src, resizeWidth = 200) => {
  if (src.endsWith(".gif")) return src;

  let srcImg = "";
  if (src && !(src.includes("http://") || src.includes("https://"))) {
    const host = NEXT_PUBLIC_IMG_SERVER;
    srcImg = host + "/w" + resizeWidth + "/uploads/" + src;
  } else {
    const width = src.split("/")[3];
    if (width) {
      const newWidth = width.includes("w")
        ? `w${resizeWidth}`
        : `w${resizeWidth}/${width}`;
      srcImg = src.replace(width, newWidth);
    } else {
      srcImg = src;
    }
  }

  return srcImg;
};

const filterCategory = (config, cateId) => {
  if (!config || !config.listCategory || !cateId) {
    return "";
  }

  if (typeof cateId === "object") {
    return cateId.name;
  }

  const category = config.listCategory.find((cate) => cate.id === cateId);

  if (category) {
    return category.name;
  }

  return "";
};

const convertTime = (timeString) => {
  const d = new Date(timeString);
  if (!d) return;
  const timeDifference = (publishedAt, timeAgo, gmt) => {

    const current = new Date();
    const previous = new Date(publishedAt);
    const elapsed = current.getTime() - previous.getTime();

    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;
    let checkTime3h = false;

    if (elapsed < msPerMinute && timeAgo) {
      return Math.round(elapsed / 1000) + ' giây trước';
    }

    else if (elapsed < msPerHour && timeAgo) {
      return `<span class=${checkTime3h ? "animation-red" : ""}>${Math.round(elapsed / msPerMinute)} phút trước </span>`;
    }

    else if (elapsed < msPerDay && timeAgo) {
      if(Math.round(elapsed / msPerHour) > 3){
        checkTime3h = true;
      }
      return `<span class=${checkTime3h ? "animation-red" : ""}>${Math.round(elapsed / msPerHour)} giờ trước </span>`;
    }

    else if (elapsed < msPerMonth && (elapsed / msPerDay) < 4) {
      checkTime3h = true;
      return `<span class=${checkTime3h ? "animation-red" : ""}>${Math.round(elapsed / msPerDay)} ngày trước</span>`;
    }

    else {
      const minute = previous.getMinutes() < 10 ? '0' + previous.getMinutes() : previous.getMinutes();
      const hour = previous.getHours();
      const date = previous.getDate() < 10 ? '0' + previous.getDate() : previous.getDate();
      const month = (previous.getMonth() + 1) < 10 ? '0' + (previous.getMonth() + 1) : (previous.getMonth() + 1);
      const year = previous.getFullYear();
      checkTime3h = true;
      if(gmt){
        return `<span class=${checkTime3h ? "animation-red" : ""}>${date}/${month}/${year} - ${hour}:${minute} GMT+7 </span>`;
      }
      return `<span class=${checkTime3h ? "animation-red" : ""}>${date}/${month}/${year} - ${hour}:${minute}</span>`;
    }

    // else if (elapsed < msPerYear) {
    //   return 'approximately ' + Math.round(elapsed / msPerMonth) + ' months ago';
    // }

    // else {
    //   return 'approximately ' + Math.round(elapsed / msPerYear) + ' years ago';
    // }
  }
  return timeDifference(timeString, true, false);
};

export {
  getHome,
  updateHome,
  buildQueryString,
  TRANSLATE,
  getPosts,
  getRealtimePosts,
  resizeImage,
  filterCategory,
  convertTime,
};
